export enum ResourceStaleTimeEnum {
  GetResource = 60000,
  GetResourcesList = 60000,
  GetOpeningHOurs = 60000,
  GetResourceOptions = 60000,
  GetResourceGroups = 60000,
  GetResourceTags = 60000,
  GetResourceStatus = 60000,
  GetResourceOverview = 60000,
  GetSuggestedResources = 30000,
  GetTimeline = 0,
}
